module.exports = __webpack_public_path__ + "img/uncheck-circle.dbaea568.svg";